import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode';
import api from '../utils/api';
import { printQrLabelBatch } from '../utils/qrLabel';

// Tokens, not the literals this arrived with: every colour in this app
// follows the theme (Task 3.3), and --c-primary IS #2c6e49.
const btnStyle = {
  background: 'var(--c-primary)',
  color: 'var(--c-on-accent-fg)',
  border: 'none',
  borderRadius: 6,
  padding: '6px 12px',
  cursor: 'pointer',
  fontSize: 13,
};

export default function QrCodeBatchGenerator() {
  const { t } = useTranslation(['collections', 'common']);
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const generate = async () => {
    setError('');
    setLoading(true);
    try {
      const n = Math.min(200, Math.max(1, Number(count) || 1));
      const res = await api.post('/qr-pool/generate', { count: n });
      const items = await Promise.all(
        res.data.codes.map((code) =>
          QRCode.toDataURL(code, { width: 220, margin: 1 }).then((dataUrl) => ({ dataUrl, text: code }))
        )
      );
      const printed = printQrLabelBatch(items);
      if (!printed) {
        setError(t('qrPool.popupBlocked'));
        return;
      }
      setOpen(false);
    } catch (e) {
      setError(e.response?.data?.error || t('qrPool.generateError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button type="button" onClick={() => setOpen((o) => !o)} title={t('common:tip.qrBatchToggle')} style={btnStyle}>
        {t('qrPool.generateButton')}
      </button>
      {open && (
        <div style={{ marginTop: 8, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <label>
            {t('qrPool.countLabel')}
            <input
              type="number"
              min="1"
              max="200"
              value={count}
              onChange={(e) => setCount(e.target.value)}
              title={t('common:tip.qrBatchCount')}
              style={{ width: 70, marginInlineStart: 6 }}
            />
          </label>
          <button type="button" onClick={generate} disabled={loading} title={t('common:tip.qrBatchPrint')} style={btnStyle}>
            {loading ? t('common:loading') : t('qrPool.printBatch')}
          </button>
          {error && <span style={{ color: 'var(--c-danger-fg)', fontSize: 13 }}>{error}</span>}
        </div>
      )}
    </div>
  );
}
